import type { LiveDemoConfig } from "~/components/siteglue/industries/shared/types";

/** Demo agent project IDs for industry landing live demo sections. */
export const INDUSTRY_LIVE_DEMO_PROJECT_IDS = {
  healthcare: "cmrklqyda0002h4xqq1kz0elt",
  churches: "cmri4ae9700029rc3x9e4o268",
  dental: "cmrmhijs70002s0xkcwljhdeh",
  insurance: "cmrm15jks00024j86i6unepsa",
  legal: "cmrkibjop000214b446pcin94",
  financial: "cmrjk865n0002hztqgoxutyub",
  "home-services": "cmrkzkxtc0002uuhrbbnwdgh5",
  "physical-therapy": "cmrhzest2000299sshellturi",
  "real-estate": "cmrrrqri900027uf5ka95l3f8",
  education: "cmrrsdci20002beb1pprp7ke8",
  retail: "cmrrsj0wh0026beb1e13p2whu",
  nonprofits: "cmrh64iid0002atyqd4eoo3pz",
} as const;

export type IndustryLiveDemoProjectKey = keyof typeof INDUSTRY_LIVE_DEMO_PROJECT_IDS;

const INDUSTRY_LIVE_DEMO_PROJECT_ID_SET = new Set<string>(
  Object.values(INDUSTRY_LIVE_DEMO_PROJECT_IDS),
);

/** True for agents embedded in SiteGlue industry/solution live demo sections. */
export function isIndustryLiveDemoProjectId(projectId: string): boolean {
  return INDUSTRY_LIVE_DEMO_PROJECT_ID_SET.has(projectId);
}

export function buildIndustryLiveDemoConfig(
  key: IndustryLiveDemoProjectKey,
  copy: Pick<LiveDemoConfig, "heading" | "lead" | "eyebrow" | "demoAgentLabel">,
): LiveDemoConfig {
  return {
    projectId: INDUSTRY_LIVE_DEMO_PROJECT_IDS[key],
    eyebrow: copy.eyebrow ?? "Live Demo",
    heading: copy.heading,
    lead: copy.lead,
    demoAgentLabel: copy.demoAgentLabel,
  };
}
